import {
  format,
  formatDuration as dtFormatDuration,
  formatDistanceToNow,
} from "date-fns";

function formatComplaintNumber(number) {
  return String(number).padStart(6, "0");
}

function timeago(val) {
  return formatDistanceToNow(new Date(val), { addSuffix: true });
}

function formatDate(val) {
  // return format(new Date(val), "dd-MM-yyyy, HH:mm xxx");
  return format(new Date(val), "dd-MM-yyyy, p");
}

function formatDateOnly(val) {
  // return format(new Date(val), "dd-MM-yyyy, HH:mm xxx");
  return format(new Date(val), "dd-MM-yyyy");
}

function formatDuration(val) {
  return dtFormatDuration({ seconds: parseInt(val) }, { format: ["minutes"] });
}

function formatNameForIcon({ firstName, lastName }) {
  if (firstName && lastName)
    return `${firstName.substr(0, 1).toUpperCase()}${lastName
      .substr(0, 1)
      .toUpperCase()}`;
}

function formatFolderId(folder) {
  return `JMESR/${folder}`;
}

export {
  timeago,
  formatDate,
  formatDateOnly,
  formatDuration,
  formatComplaintNumber,
  formatNameForIcon,
  formatFolderId,
};
